import React from "react";
import styles from "./Visncare.module.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom'
// Promo slider (Award + Practice Assessment) shown above the Deseyne logo.
// To disable the whole promo section, comment out this single import line and
// the <PromoSlider /> usage below.
import PromoSlider from "./PromoSlider/PromoSlider";

// Award image is temporarily hidden. Flip back to `true` to restore it without
// rewriting anything.
const SHOW_AWARD = false;

const Visncare = () => {
  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
    vertical: false,
  };

  return (
    <section>
      <div className={styles.heroSection}>
        <div className={styles.Slider_section} style={{ backgroundImage: 'url(/Images/BMD-Bg2.webp)' }}>
          <Slider {...settings}>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 1.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" fetchPriority="high" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 2.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 3.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 4.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 5.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
            <div className={styles.Img_div}>
              <img src="Images/Images for Carousel_ 6.webp" alt="carousel of happy people with healthy eyes on Deseyne® product packaging" />
            </div>
           

          </Slider>
          {/* Award Image - Temporarily Hidden (kept for easy restore) */}
          {SHOW_AWARD && (
            <div className={styles.AwardImg}>
              <img src="/Images/Award_bug.webp" alt="Award_bug" />
            </div>
          )}

        </div>
        <div className={styles.content_section}>
          <div className={styles.tittle}>
            {/* Promo slider above the Deseyne logo. Comment out this single line
                to disable the whole promo section. */}
            <PromoSlider />
            <div className={styles.DeseyneLogo}>
              <img className={styles.Deseyne_Logo} src='Images/Deseyne Logo.webp' alt='Deseyne® product logo' />
              {/* Award Image - Temporarily Hidden (kept for easy restore) */}
              {SHOW_AWARD && (
                <Link to="/deseyne-medtech-breakthrough-award-2026">
                  <img
                    className={styles.awardimage}
                    src="/Images/Award_bug.webp"
                    alt="Award_bug"
                    style={{ cursor: 'pointer' }}
                  />
                </Link>
              )}
            </div>
            <div className={styles.subtitle}><h1>Daily Disposable Soft Contact lens for Presbyopia with Extended Depth of Focus <span className=".diffentFamily">(</span>EDOF<span className="diffentFamily">)</span> </h1></div>
            <p className={styles.titpara}>Continuous Focus from Near to Far</p>
            <div className={styles.logo_edof}><img src="/Images/edof_group.webp" alt="logo_edof" /></div>
            <div className={styles.description}>
              <h3 className={styles.desc}>Superior visual acuity without a multifocal</h3>
              {/* <p className={styles.learnMoreText}>LEARN MORE About Deseyne®</p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visncare;
